//* Vue
import { ExtractPropTypes, PropType } from "vue";

//* 表格配置项
export const UiSimplebarPropsOption = {
    height: { type: [Number, String] as PropType<number | string> },
    spacing: { type: Number, default: 2 },
    trigger: { type: String as PropType<"Hover"> },
} as const;

//* 表格配置项类型
export type UiSimplebarProps = ExtractPropTypes<typeof UiSimplebarPropsOption>;
export const UiSimplebarEmits = {
    scroll: (_ev: Event) => true,
};
